































































































































import { Watch, BaseTLComponent, Component, ScheduleService, ScheduleLimitationService, Prop, tlISODateWithoutYearToLocalString, tlISOTimeWithoutSecondToLocalString, tlISOTimeToLocalStringForm } from "../../Infrastructure/CorBase/CoreBase";


@Component
export default class BaseTLSchedule extends BaseTLComponent {
	@Prop({ type: Number, required: false, default: 0 }) idSchedule!: number; //větší pismo
	@Prop({ type: Boolean, required: false, default: false }) isUpdate?: boolean;
	@Prop({ type: Boolean, required: false, default: false }) useTime?: boolean;

	selected: any[] = []; // vybrane dny
	selectedOld: any[] = []; //původní
	options = [
		{ text: 'Pondělí', value: 1 },
		{ text: 'Úterý', value: 2 },
		{ text: 'Středa', value: 3 },
		{ text: 'Čtvrtek', value: 4 },
		{ text: 'Pátek', value: 5 },
		{ text: 'Sobota', value: 6 },
		{ text: 'Neděle', value: 7 },
	];
	isUnlimited = true;
	isNotActiveInLimitation = true;
	scheduleItems: any[] = [];
	selectedScheduleId: number = 0;
	limitTime: boolean = false;
	labelCheckBoxWidth: string = "2";
	inputCheckBoxWidth: string = "1";
	labelWidth: string = "2";
	inputWidth: string = "6";

	_timeDayFromForm = '';
	_timeDayFromTo = '';

	labelWidthTime: string = "2";
	inputWidthTime: string = "4";

	dayLimit: string = '';
	editedDayLimit: string = '';

	idWorkingUnit: number = 0;
	type: string = '';
	idScheduleLimitSelected: number = 0;
	updateMode: boolean = false;
	isBusy = true;
	daysText = '';
	isNotAllowAdd = false;

	changeType(typ: any) {
		this.type = typ;
	}

	//test
	@Watch('type')
	onPropertyChanged(value: string, oldValue: string) {
		if (value !== oldValue) {
			if (value == 'date') {
				if (oldValue != '') {
					this.limitTime = false;
				}
			}
			if (value == 'day') {
				this.formTypeLimit.from = this._timeDayFromForm;
				this.formTypeLimit.to = this._timeDayFromTo;
				if (this._timeDayFromTo != '') {
					this.limitTime = true;
				}
			}
		}
	}

	existLimit() {
		return this.scheduleItems.length > 0 || this.isUpdate == false;
	}

	showTimeLimit() {
		return this.useTime && (this.type == 'date' || this.type == 'day');
	}

	types = [
		{ value: 'date', text: 'Zadat datum' },
		{ value: 'day', text: 'Dny v týdnu' }];

	scheduleService: ScheduleService = new ScheduleService();
	scheduleLimitService: ScheduleLimitationService = new ScheduleLimitationService();

	nameButtonSave() {
		return this.isEditDate() ? 'Přidat' : 'Uložit';
	}

	isEditDate() {
		return this.type == 'date';
	}

	notAllowEdit() {
		return this.dayLimit == '';
	}

	notAllowAdd() {
		this.isNotAllowAdd = false;
		if (this.limitTime && (!this._isCorrect1 || !this._isCorrect2)) {
			this.isNotAllowAdd = true;
			return true
		}

		if (this.isEditDate()) {
			if (this.dayLimit == '') {
				this.isNotAllowAdd = true;
				return true;
			}

			// VaP - pokud edituju zvoleny den, tak umoznim jeho ulozeni, u ostatnich to pohlidame, at nejde editovat nebo vytvaret jiz existuji den
			if (this.dayLimit == this.editedDayLimit) {
				this.isNotAllowAdd = false;
				return false;
			}

			this.isNotAllowAdd = this.scheduleItems.filter(c => c.month == this.getMonth() && c.day == this.getDay()).length > 0;
			return this.scheduleItems.filter(c => c.month == this.getMonth() && c.day == this.getDay()).length > 0;
		}
		return this.dayLimit != '';
	}

	limitTimeSel(): boolean {
		return true;
	}

	showAddButton() {
		return !this.updateMode && this.type != '';
	}

	formDataSchedule = {
		id: 0,
		idTenant: this.$store.state.idTenant,
		name: '',
		description: '',
		isUnlimited: false,
		to: '',
		from: ''
	}

	formTypeLimit = {
		id: 0,
		idSchedule: 0,
		day: 0,
		month: 0,
		week: 0,
		isActiveInLimitation: false,
		allDaysRemove: '',
		allDaysAdd: '',
		isEditDays: false,
		from: '' as string | null,
		to: '' as string | null
	}

	fields() {
		let result = [
			{ key: 'name', label: 'Výběr', sortable: true, class: 'text-center' },
			{ key: 'description', label: 'Kdy', sortable: true, class: 'text-center' },
			{ key: 'isActiveInLimitationText', label: 'Platnost ', sortable: true, class: 'text-center' },
		];

		if (this.useTime) {
			result.push({ key: 'from', label: 'Od', sortable: true, class: 'text-center' });
			result.push({ key: 'to', label: 'Do', sortable: true, class: 'text-center' });
		}

		if (this.isUpdate) {
			result.push({ key: 'actions', label: 'Volby', sortable: false, class: 'text-right' });
		}
		return result;
	}

	getMonth(): number {
		let result: number = 0;
		if (this.dayLimit != '') {
			result = Number(this.dayLimit.substr(5, 2));
		}
		return result;
	}

	getDay(): number {
		let result: number = 0;
		if (this.dayLimit != '') {
			result = Number(this.dayLimit.substr(8, 2));
		}
		return result;
	}

	getAllDays(isAdd: boolean) {
		let result = '';
		if (isAdd) {//vybrana na pridani
			for (var i = 0; i < this.selected.length; i++) {
				result += this.selectedOld.indexOf(this.selected[i]) == -1 ? this.selected[i] + '|' : '';
			}
		}
		else {
			for (var i = 0; i < this.selectedOld.length; i++) {
				result += this.selected.indexOf(this.selectedOld[i]) == -1 ? this.selectedOld[i] + '|' : '';
			}
		}

		if (result != '') {
			result = result.substr(0, result.length - 1);
		}
		return result;
	}

	created() {
		super.initializeRights('SHP_WorkingUnit_Create', 'SHP_WorkingUnit_Delete', 'SHP_WorkingUnit_Read', 'SHP_WorkingUnit_Update');
		this.idWorkingUnit = this.objectIdFromParam;
		this.fetch();
	};

	idScheduleOld = 0;
	itemsMain() {
		if (this.idSchedule != this.idScheduleOld) {
			this.idScheduleOld = this.idSchedule;
			this.fetch();
		}
		return this.scheduleItems;
	}


	createScheduleLimit() {
		this.formTypeLimit.id = 0;
		this.formTypeLimit.month = this.getMonth();
		this.formTypeLimit.day = this.getDay();
		this.formTypeLimit.idSchedule = this.idSchedule;


		if (this.limitTime == false) {
			//docasne pryc
			this.formTypeLimit.to = '11:11:11';
			this.formTypeLimit.from = '11:11:11';
			//delete this.formTypeLimit.to;
			//delete this.formTypeLimit.from;
		}


		if (this.isEditDate()) {
			this.formTypeLimit.isEditDays = false;
			delete this.formTypeLimit.week;
			this.formTypeLimit.allDaysAdd = '';
			this.formTypeLimit.allDaysRemove = '';
			this.formTypeLimit.isActiveInLimitation = !this.isNotActiveInLimitation;
			this.isNotActiveInLimitation = false;
		}
		else {
			delete this.formTypeLimit.month;
			this.formTypeLimit.week = 0;
			this.formTypeLimit.isEditDays = true;
			this.formTypeLimit.allDaysAdd = this.getAllDays(true);
			this.formTypeLimit.allDaysRemove = this.getAllDays(false);
			this.formTypeLimit.isActiveInLimitation = true;
		}

		// VaP - tychly hack, at to jde ulozit, pokud se posle prazdny retezec, tak to spadne s 500 ze nejde '' prevest na timespan
		//         - https://redmine.trustlab.cz/issues/255
		if (this.formTypeLimit.to == '') {
			this.formTypeLimit.to = null;
		}
		if (this.formTypeLimit.from == '') {
			this.formTypeLimit.from = null;
		}
		this.scheduleLimitService.create(this.formTypeLimit).then(() => {
			if (this.scheduleItems.length == 0) {
				this.updateScheduleUnlimited(false);
			}
			this.fetch();
		});
	}




	updateSchedule() {
		this.formTypeLimit.month = this.getMonth();
		this.formTypeLimit.day = this.getDay();
		this.formTypeLimit.idSchedule = this.idSchedule;
		this.formTypeLimit.id = this.idScheduleLimitSelected;
		this.formTypeLimit.isActiveInLimitation = !this.isNotActiveInLimitation;

		if (this.limitTime == false) {
			//delete this.formTypeLimitSave.to;
			//delete this.formTypeLimitSave.from;
			//Tady bohuzel nelze pouzit delete, protoze to rozmrda komponentu s casem....nereaguje na zmeny
			this.formTypeLimit.to = '11:11:11';
			this.formTypeLimit.from = '11:11:11';
		}

		// VaPTODO - tychly hack, at to jde ulozit, pokud se posle prazdny retezec, tak to spadne s 500 ze nejde '' prevest na timespan
		//         - https://redmine.trustlab.cz/issues/255
		if (this.formTypeLimit.to == '') {
			this.formTypeLimit.to = null;
		}
		if (this.formTypeLimit.from == '') {
			this.formTypeLimit.from = null;
		}
		this.scheduleLimitService.update(Number(this.formTypeLimit.id), this.formTypeLimit).then(() => {
		}).then(() => {
			this.goBack();
			this.fetch();
		}
		);
	};

	updatePrepare(scheduleLimitId: any) {
		this.selected = this.selectedOld;
		this.idScheduleLimitSelected = scheduleLimitId;
		this.updateMode = true;
		this.type = this.scheduleItems.filter(c => c.id == scheduleLimitId)[0].id == -1 ? 'day' : 'date';
		this.formTypeLimit.month = this.scheduleItems.filter(c => c.id == scheduleLimitId)[0].month;
		this.formTypeLimit.week = this.scheduleItems.filter(c => c.id == scheduleLimitId)[0].week;
		this.formTypeLimit.day = this.scheduleItems.filter(c => c.id == scheduleLimitId)[0].day;

		this.formTypeLimit.from = this.scheduleItems.filter(c => c.id == scheduleLimitId)[0].fromForm;
		this.formTypeLimit.to = this.scheduleItems.filter(c => c.id == scheduleLimitId)[0].toForm;

		this.limitTime = this.formTypeLimit.from != '';
		this.isNotActiveInLimitation = !this.scheduleItems.filter(c => c.id == scheduleLimitId)[0].isActiveInLimitation;
		let year = new Date().getFullYear().toString();
		if (this.isEditDate()) {
			let dateText = year;
			dateText += '-' + (this.formTypeLimit.month < 10 ? ('0' + this.formTypeLimit.month) : this.formTypeLimit.month);
			dateText += '-' + (this.formTypeLimit.day < 10 ? ('0' + this.formTypeLimit.day) : this.formTypeLimit.day);
			this.dayLimit = dateText;
			this.editedDayLimit = dateText;
		}
		else {
			this.dayLimit = '';
			this.editedDayLimit = '';
		}
	}

	goBack() {
		this.updateMode = false;
		this.type = '';
		this.dayLimit = '';
		this.isNotActiveInLimitation = false;
		this.formTypeLimit.to = '';
		this.formTypeLimit.from = '';
		this.selected = this.selectedOld;
	}

	deleteAction(scheduleLimitedId: any) {
		if (scheduleLimitedId > 0) {
			this.deleteLimitation(scheduleLimitedId);
		}
		else {
			this.selected = [];
			this.createScheduleLimit();
			if (this.scheduleItems.length == 1) {
				this.updateScheduleUnlimited(true);
			}
		}
	}

	updateScheduleUnlimited(isUnulimited: boolean) {
		this.formDataSchedule.isUnlimited = isUnulimited;
		if (this.limitTime == false) {
			//delete this.formTypeLimit.to;
			//delete this.formTypeLimit.from;
			this.formTypeLimit.to = '11:11:11';
			this.formTypeLimit.from = '11:11:11';
		}
		this.scheduleService.update(this.idSchedule, this.formDataSchedule);
	}

	deleteLimitation(scheduleLimitedId: any) {
		this.scheduleLimitService.delete(scheduleLimitedId).then(() => {
		}).then(() => {
			if (this.scheduleItems.length == 1) {
				this.updateScheduleUnlimited(true);
			}
			this.fetch();
		}
		).catch((error) => {
			//	this.showAlertModalWithTitleAndContent('Chyba', JSON.stringify(error.response.data.errors));
		})
	};


	loadDays(days: number[]) {
		let result = '';
		result += days.indexOf(1) != -1 ? 'Pondělí,' : '';
		result += days.indexOf(2) != -1 ? 'Úterý,' : '';
		result += days.indexOf(3) != -1 ? 'Středa,' : '';
		result += days.indexOf(4) != -1 ? 'Čtvrtek,' : '';
		result += days.indexOf(5) != -1 ? 'Pátek,' : '';
		result += days.indexOf(6) != -1 ? 'Sobota,' : '';
		result += days.indexOf(7) != -1 ? 'Neděle,' : '';

		for (var i = 0; i < days.length; i++) {
			this.selected.push(days[i]);
			this.selectedOld.push(days[i]);
		}
		if (result != '') {
			result = result.substr(0, result.length - 1);
		}
		this.daysText = result;
	}


	fetch() {


		this.selected = [];
		this.selectedOld = [];
		this.scheduleItems = [];
		if (this.idSchedule > 0) {
			this.scheduleService.getById(this.idSchedule).then((response) => {
				this.formDataSchedule.id = response.data.id;
				this.formDataSchedule.idTenant = response.data.idTenant;
				this.formDataSchedule.description = response.data.description;
				this.formDataSchedule.name = response.data.name;

				var timeFrom, timeTo, timeToForm, timeFromForm, timeDayFrom, timeDayTo, timeDayToForm, timeDayFromForm;
				let days: number[] = [];

				for (var i = 0; i < response.data.scheduleLimitationList.length; i++) {
					let item = response.data.scheduleLimitationList[i];
					timeFrom = tlISOTimeWithoutSecondToLocalString(item.from);
					timeTo = tlISOTimeWithoutSecondToLocalString(item.to);
					timeFromForm = tlISOTimeToLocalStringForm(item.from);
					timeToForm = tlISOTimeToLocalStringForm(item.to);

					//jednotlive dny v týdnu
					if (item.day != undefined && item.week != undefined && item.month == undefined) {
						timeDayFrom = tlISOTimeWithoutSecondToLocalString(item.from);
						timeDayTo = tlISOTimeWithoutSecondToLocalString(item.to);
						this._timeDayFromForm = timeDayFromForm = tlISOTimeToLocalStringForm(item.from);
						this._timeDayFromTo = timeDayToForm = tlISOTimeToLocalStringForm(item.to);

						days.push(item.day);
					}
					//datum
					if (item.day != undefined && item.week == undefined && item.month != undefined) {
						let dateDay = tlISODateWithoutYearToLocalString(item.date);
						let isActive = item.isActiveInLimitation ? 'Ano' : 'Neplatí pro tento den';
						this.scheduleItems.push({ id: item.id, type: 'date', name: 'Datum', day: item.day, month: item.month, week: item.week, description: dateDay, isActiveInLimitationText: isActive, isActiveInLimitation: item.isActiveInLimitation, from: timeFrom, to: timeTo, fromForm: timeFromForm, toForm: timeToForm });
					}
				}

				//dny v týdnu
				if (days.length > 0) {
					this.loadDays(days);

					this.scheduleItems.push({ id: -1, type: 'day', name: 'Ve dny', day: 999, month: 999, week: 999, description: this.daysText, from: timeDayFrom, to: timeDayTo, fromForm: timeDayFromForm, toForm: timeDayToForm });
				}
				this.isUnlimited = this.scheduleItems.length == 0;
				this.goBack();
				this.isBusy = false;
			});
		}
	}

	_isCorrect1: boolean = false;
	_isCorrect2: boolean = false;

	isCorrect1(value: any) {
		this._isCorrect1 = value;
		this.notAllowAdd();
	}
	isCorrect2(value: any) {
		this._isCorrect2 = value;
		this.notAllowAdd();
	}

};
